module.exports = __webpack_public_path__ + "img/payment-icon.1f782fad.png";